// extracted by mini-css-extract-plugin
export default {"CloseSidebarButton":"_CloseSidebarButton--_vR9h"};